var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheetEyeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50.0 50.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920,0 L1920,1259 L0,1259 L0,0 L1920,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C38.8071187,-2.53632657e-15 50,11.1928813 50,25 C50,38.8071187 38.8071187,50 25,50 C11.1928813,50 1.69088438e-15,38.8071187 0,25 C-1.69088438e-15,11.1928813 11.1928813,2.53632657e-15 25,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C19.5395016,0 24.370983,4.32926006 26.7761928,6.98252713 L26.9329268,7.15686275 C27.5731707,7.99719888 28,8.94957983 28,10 C28,11.0504202 27.5731707,12.1008403 26.9329268,12.8431373 C24.5853659,15.4761905 19.7764228,20 14,20 C8.46049841,20 3.62901701,15.6707399 1.22380716,13.0174729 L1.06707317,12.8431373 C0.426829268,12.0028011 0,11.0504202 0,10 C0,8.94957983 0.426829268,7.89915966 1.06707317,7.15686275 C3.41463415,4.42577031 8.33739837,0 14,0 Z M14,2.43697479 C9.29065041,2.43697479 5.12195122,6.44257703 2.98780488,8.7535014 C2.66056911,9.07563025 2.56097561,9.49579832 2.56097561,9.91596639 C2.56097561,10.3361345 2.67479675,10.7563025 2.98780488,11.0784314 C5.12195122,13.3893557 9.40447154,17.394958 14,17.394958 C18.7093496,17.394958 22.8780488,13.3893557 25.0121951,11.0784314 C25.3394309,10.7563025 25.4390244,10.3361345 25.4390244,9.91596639 C25.4390244,9.49579832 25.3252033,9.07563025 25.0121951,8.7535014 C22.9918699,6.42857143 18.7093496,2.43697479 14,2.43697479 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 C6.36111111,0 7.61111111,0.527777778 8.54166667,1.45833333 C9.48611111,2.40277778 10,3.65277778 10,5 C10,6.36111111 9.47222222,7.61111111 8.54166667,8.54166667 C7.61111111,9.47222222 6.36111111,10 5,10 C3.63888889,10 2.38888889,9.47222222 1.45833333,8.54166667 C0.513888889,7.59722222 0,6.34722222 0,5 C0,3.63888889 0.527777778,2.38888889 1.45833333,1.45833333 C2.40277778,0.513888889 3.65277778,0 5,0 Z M5,2.58333333 C4.375,2.58333333 3.75,2.90277778 3.22222222,3.31944444 C2.80555556,3.73611111 2.48611111,4.47222222 2.48611111,5.09722222 C2.48611111,5.72222222 2.80555556,6.34722222 3.22222222,6.875 C3.63888889,7.29166667 4.375,7.61111111 5,7.61111111 C5.625,7.61111111 6.25,7.29166667 6.77777778,6.875 C7.19444444,6.45833333 7.51388889,5.72222222 7.51388889,5.09722222 C7.51388889,4.47222222 7.19444444,3.84722222 6.77777778,3.31944444 C6.36111111,2.79166667 5.73611111,2.58333333 5,2.58333333 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1580.0 -15.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1580.0 15.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 50,0 50,50 0,50 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "25.1306443%"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.0 15.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 28,0 28,20 0,20 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.0 5.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 10,0 10,10 0,10 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetEyeIcon);
export default __webpack_public_path__ + "static/media/sheet-eye-icon.57fcb6c1080a47658605b25f9b01bc09.svg";
export { ForwardRef as ReactComponent };